import { render, staticRenderFns } from "./CatalogFaq.vue?vue&type=template&id=73ec0f8c&"
import script from "./CatalogFaq.js?vue&type=script&lang=js&"
export * from "./CatalogFaq.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports